export default __webpack_public_path__ + "static/media/www.7aeef4b1.svg";